module.exports = window.DecorationComps;